import { Link } from 'react-router-dom'
import { ArrowLeft, Home } from 'lucide-react'
import notFoundImage from '../assets/404.png'

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Image 404 en pleine largeur avec texte superposé */}
      <div className="relative w-full">
        <img 
          src={notFoundImage} 
          alt="Page non trouvée" 
          className="w-full h-auto min-h-[100vh] object-cover"
        />
        
        {/* Contenu superposé sur l'image */}
        <div className="absolute inset-0 flex flex-col items-center justify-between text-center px-4 py-4 md:py-8">
          {/* Texte d'erreur en haut */}
          <div className="flex-1 flex flex-col items-center justify-center pt-8 md:pt-0">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4 drop-shadow-lg">
              Prise ratée ! Erreur 404
            </h1>
            <p className="text-sm md:text-lg lg:text-xl text-white mb-2 drop-shadow-md px-2">
              La page que vous cherchez n'existe pas ou a été coupée au montage.
            </p>
          </div>

          {/* Boutons et liens en bas */}
          <div className="w-full max-w-md pb-4 md:pb-8">
            {/* Boutons d'action */}
            <div className="space-y-2 md:space-y-3 mb-4 md:mb-6">
              <Link
                to="/"
                className="btn-primary w-full flex items-center justify-center bg-white text-gray-900 hover:bg-gray-100 border-2 border-white text-sm md:text-base py-2 md:py-3"
              >
                <Home className="h-4 w-4 mr-2" />
                Retour à l'accueil
              </Link>
              
              <button
                onClick={() => window.history.back()}
                className="w-full flex items-center justify-center px-4 py-2 md:py-3 bg-transparent text-white border-2 border-white rounded-lg hover:bg-white hover:text-gray-900 transition-colors text-sm md:text-base"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Page précédente
              </button>
            </div>

            {/* Liens utiles */}
            <div className="border-t border-white/30 pt-3 md:pt-4">
              <p className="text-xs md:text-sm text-white mb-3 md:mb-4 drop-shadow-md">
                Vous cherchez peut-être :
              </p>
              <div className="flex flex-wrap justify-center gap-2 md:gap-3">
                <Link 
                  to="/catalogue-materiels" 
                  className="text-xs md:text-sm text-white hover:text-yellow-300 transition-colors drop-shadow-md"
                >
                  Catalogue
                </Link>
                <Link 
                  to="/filmographie" 
                  className="text-xs md:text-sm text-white hover:text-yellow-300 transition-colors drop-shadow-md"
                >
                  Filmographie
                </Link>
                <Link 
                  to="/contact" 
                  className="text-xs md:text-sm text-white hover:text-yellow-300 transition-colors drop-shadow-md"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
